import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Alert, Button } from "react-bootstrap";
import { useGlobalState } from "../../contexts/GlobalStateContext";
import { useUserAuth } from "../context/UserAuthContext";
import axios from 'axios'

const Login = () => {
  const { t, API_PATH } = useGlobalState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { logIn, logOut } = useUserAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await logIn(email, password);
      axios.post(API_PATH + 'user-access-rights.php', { action: 'read', email: email })
        .then(res => {
          if (res.data.active === '1') {
            navigate("/dashboard");
          } else {
            logOut()
            setError('Mitarbeiter-Konto ist nicht aktiv.')
          }
        })
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <div className="p-5 box mt-4 text-center col-12 col-sm-10 col-md-8 col-lg-5">
        <h3 className="mb-4">{t('Auth.heading_login', { ns: 'internal' })}</h3>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control
              type="email"
              placeholder={t('App.email')}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Control
              type="password"
              placeholder={t('Auth.password', { ns: 'internal' })}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="mt-1 text-center">
              <Link to="/forgot-password">{t('Auth.forgot_password', { ns: 'internal' })}</Link>
            </div>
          </Form.Group>

          <div className="d-grid gap-2">
            <Button variant="primary" type="Submit">
              {t('Auth.log_in', { ns: 'internal' })}
            </Button>
          </div>
        </Form>
      </div>
      <div className="p-4 box mt-3 text-center col-12 col-sm-10 col-md-8 col-lg-5">
        {t('Auth.dont_have_an_account', { ns: 'internal' })} <Link to="/signup">{t('Auth.sign_up', { ns: 'internal' })}</Link>
      </div>
    </>
  );
};

export default Login;